// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Products_UploadImageInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/products/upload_image
 *
 * Multipart form: typed fields (so_product_id, optional metadata) plus the
 * image file delivered as `$_FILES['imagem_nome']` (read by the controller
 * outside this contract — multipart files do not pass through typed
 * properties).
 *
 * The file's own validation (size, MIME, extension, getimagesize) is the
 * controller's responsibility; the parent-product existence check is also
 * the controller's responsibility. This contract only guards the typed fields.
 */
import { registerContract } from './validate'

export interface Products_UploadImageInput {
so_product_id: number
so_product_image_alt_text?: string
so_product_image_sort_order?: number
so_product_image_is_primary?: boolean
}

registerContract('Products_UploadImageInput', {
  so_product_id:               { type: 'number',  required: true },
  so_product_image_alt_text:   { type: 'string',  required: false },
  so_product_image_sort_order: { type: 'number',  required: false },
  so_product_image_is_primary: { type: 'boolean', required: false },
})
